import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 8C286097-F93C-490C-A01F-BB1445A6953C
 * name medication-outline
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/medication-outline.svg
 * tags
 * - Health / Beauty 
 * - Medical / Hospital 
 */
export const MedicationOutlineIcon = createSvgIcon(<><path d="M10.5 15H8V12H10.5V9.5H13.5V12H16V15H13.5V17.5H10.5V15M19 8V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V8C5 6.9 5.9 6 7 6H17C18.1 6 19 6.9 19 8M17 8H7V19H17V8M18 3H6V5H18V3" /></>, 'MedicationOutlineIcon');
export default MedicationOutlineIcon